import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Project from "./views/Project";
import Dashboard from "./views/Dashboard";
import Documents from "./views/Documents";
import Proposals from "./views/Proposals";
import Account from "./views/Account";
import Proposal from "./views/Proposal";
import Host from "./views/Host";
import Signup from "./views/Signup";
import ProjectWizard from "./views/ProjectWizard";
import Referer from "./views/Referer";
import PasswordRenewal from "./views/PasswordRenewal";
import CompanyReferer from "./views/CompanyReferer";
import CguSign from "./views/CguSign";
import SignatureCoRequester from "./views/SignatureCoRequester";
import SignatureDone from "./views/SignatureDone";

Vue.use(Router);

const companyRefererName = localStorage.getItem("companyRefererName");
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      meta: { layout: "empty", title: "Accueil" },
      component: Home
    },
    {
      path: "/cgu",
      name: "cgu",
      meta: { layout: "empty", title: "Conditions générales d'utilisation" },
      component: CguSign
    },
    {
      path: "/_u/password",
      name: "renewpassword",
      meta: {
        layout: "empty",
        title: "Renouvellement de mot de passe",
        create: false
      },
      component: PasswordRenewal
    },
    {
      path: "/_u/createpassword",
      name: "createpassword",
      meta: {
        layout: "empty",
        title: "Création de mot de passe",
        create: true
      },
      component: PasswordRenewal
    },
    {
      path: "/signup",
      name: "signup",
      meta: { layout: "empty" },
      component: Signup
    },
    {
      path: "/ref/:trigram",
      name: "ref",
      meta: { layout: "empty" },
      component: Referer
    },
    {
      path: "/refc/groupeigs",
      redirect: "/refc/0076/groupeigs"
    },
    {
      path: "/refc/:shortid/:techname",
      name: "refc",
      meta: { layout: "empty" },
      component: CompanyReferer
    },
    {
      path: "/account",
      name: "account",
      meta: { layout: "default", title: "Mon compte" },
      component: Account
    },
    {
      path: "/create-project",
      name: "project-new",
      meta: {
        layout: "default",
        tab: 1,
        title: companyRefererName
          ? `${companyRefererName} - Création de projet`
          : "Création de projet"
      },
      component: ProjectWizard
    },
    {
      path: "/leases/project/:lease_id/edit",
      name: "project",
      meta: { layout: "default", tab: 1, title: "Mon projet" },
      component: Project
    },
    {
      path: "/leases/project/:lease_id",
      name: "dashboard",
      meta: { layout: "default", tab: 0, title: "Tableau de bord" },
      component: Dashboard
    },
    {
      path: "/leases/project/:lease_id/documents",
      name: "documents",
      meta: { layout: "default", tab: 2, title: "Documents" },
      component: Documents
    },
    {
      path: "/leases/project/:lease_id/proposals",
      name: "proposals",
      meta: { layout: "default", tab: 3, title: "Propositions" },
      component: Proposals
    },
    {
      path: "/leases/project/:lease_id/proposals/:host_id",
      name: "proposal",
      meta: { layout: "default", tab: 3, title: "Proposition" },
      component: Proposal,
      props: { initialTab: 0 }
    },
    {
      path: "/leases/project/:lease_id/proposals/:host_id/comments",
      name: "proposal",
      meta: { layout: "default", tab: 3, title: "Proposition" },
      component: Proposal,
      props: { initialTab: 2 }
    },
    {
      path: "/hosts/project/:host_id",
      name: "host",
      meta: { layout: "anon", tab: 1, title: "Partage de biens" },
      component: Host
    },
    {
      path: "/private/signature/corequester/:encodedParam",
      name: "signature-corequester",
      meta: {
        layout: "empty-with-navbar",
        title: "Home in Love | Signature du co-demandeur"
      },
      component: SignatureCoRequester
    },
    {
      path: "/private/signature/:encodedParam/done",
      name: "signature-done",
      meta: { layout: "empty", title: "Signature effectuée" },
      component: SignatureDone
    }
  ]
});
